import { UserState } from "../types/user-state/user-state.interface";
import { createUserState } from "../types/user-state/user-state.functions";
import { UserActions, UserActionsType } from "./user.actions";

const userReducer = (state: UserState = createUserState(), action: UserActionsType): UserState => {
  switch (action.type) {
    case UserActions.Reset:
      return createUserState();
    case UserActions.SetUser:
      return {
        ...state,
        profile: action.payload,
      };
    case UserActions.FetchUserData:
    case UserActions.LoadingUser:
      return {
        ...state,
        loading: true,
      };
    case UserActions.FetchUserDataSuccess:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default userReducer;
